export const CARD_MEDIUM = {
  grid: {
    xs: 12,
    sm: 6,
    lg: 4,
  },
  containerSpacing: 3,
  radius: 3,
  accentBar: 5,
  imageHeight: 150,
  iconBox: 132,
  iconFontSize: 60,
  padding: 4,
  stackSpacing: 2,
  titleVariant: 'subtitle1',
  titleLines: 2,
  kindFontSize: 0.8,
  letterSpacing: 0.8,
  buttonDirection: 'row',
  buttonSize: 'medium',
  buttonRadius: 2,
  buttonPx: 3,
  showCtaIcon: true,
  checkIconSize: 24,
  checkOffset: 10,
};
export const CARD_SMALL = {
  grid: {
    xs: 6,
    sm: 4,
    lg: 3,
  },
  containerSpacing: 2,
  radius: 2,
  accentBar: 3,
  imageHeight: 96,
  iconBox: 64,
  iconFontSize: 30,
  padding: 2,
  stackSpacing: 1,
  titleVariant: 'body2',
  titleLines: 2,
  kindFontSize: 0.5,
  letterSpacing: 0.5,
  buttonDirection: 'column',
  buttonSize: 'small',
  buttonRadius: 1.5,
  buttonPx: 1.5,
  showCtaIcon: false,
  checkIconSize: 20,
  checkOffset: 6,
};
export const CARD_SIZES = { small: CARD_SMALL, medium: CARD_MEDIUM, large: { ...CARD_MEDIUM } };
